module.exports = __webpack_public_path__ + "img/edit.cbc76a29.svg";